import classnames from 'classnames';
import { ReactComponent as ChevroneDownIcon } from '@Icons/additional/chevrone-down.svg';
import { MButton, MCollapse } from '@Components/Base';
import { CollapseProps, Flex, Form, Typography } from 'antd';

import { FormikProps } from 'formik';

import styles from './filter.module.css';

const ERROR_TEXT = 'The filter is empty, please choose items for filtering';

interface FiltersProps<T> {
  formik: FormikProps<T>;
  items: CollapseProps['items'];
  showError?: boolean;
  onClearAll?: () => void; // Add onClearAll prop
}

const RenderIcon: CollapseProps['expandIcon'] = ({ isActive }) => (
  <ChevroneDownIcon style={{ transform: `rotate(${isActive ? 180 : 0}deg)` }} />
);

const MFilter = <T,>(props: FiltersProps<T>): JSX.Element => {
  const { formik, items, showError = false, onClearAll } = props;

  const onReset = (): void => {
    if (onClearAll) {
      onClearAll(); // Use custom clear function if provided
    } else {
      formik.resetForm(); // Fallback to default behavior
    }
  };

  return (
    <Form
      className={styles.filterContainer}
      layout="vertical"
      onFinish={formik.handleSubmit}
    >
      <MCollapse
        expandIcon={RenderIcon}
        className={classnames(styles.filterContent, 'filter-content-mobile')}
        items={items}
      />
      <Flex vertical className={styles.buttonsWrapper}>
        <Typography.Text className={styles.error}>
          {showError ? ERROR_TEXT : null}
        </Typography.Text>
        <Flex gap={16} justify="space-around" className={styles.filterButtons}>
          <Form.Item style={{ width: '100%' }}>
            <MButton
              className={styles.clearButton}
              htmlType="button"
              type="secondary"
              onClick={onReset}
            >
              Clear All
            </MButton>
          </Form.Item>
          <Form.Item style={{ width: '100%' }}>
            <MButton style={{ width: '100%' }} type="primary" htmlType="submit">
              Apply
            </MButton>
          </Form.Item>
        </Flex>
      </Flex>
    </Form>
  );
};

export default MFilter;
